import { useTranslation } from "react-i18next";
import "./style.css";
import knowledgeHeroImage from "../../assets/banner/introduce/banner.png";

const Knowledge = () => {
  const { t } = useTranslation();

  return (
    <>
      {/* Hero Section */}
      <section className="knowledge-hero" style={{ backgroundImage: `url(${knowledgeHeroImage})` }}>
        <div className="knowledge-hero-content">
          <h1 className="font-bauhaus-medium">{t("knowledge.hero.title")}</h1>
          <div className="hero-description">
            <p className="font-tomorrow">{t("knowledge.hero.description1")}</p>
            <p className="font-tomorrow">{t("knowledge.hero.description2")}</p>
          </div>
          <div className="hero-cta-buttons">
            <button className="btn-cta-primary">
              {t("knowledge.hero.cta1")}
            </button>
            <button className="btn-cta-secondary">
              {t("knowledge.hero.cta2")}
            </button>
          </div>
        </div>
      </section>

      {/* Crypto Academy Section */}
      <section className="knowledge-academy-section">
        <div className="knowledge-content-container">
          <div className="section-header">
            <div className="section-subtitle font-tomorrow">
              {t("knowledge.academy.sectionTitle")}
            </div>
            <h2 className="section-title font-bauhaus-medium">
              {t("knowledge.academy.title")}
            </h2>
          </div>
          
          <div className="academy-grid">
            <div className="academy-card">
              <div className="academy-badge font-tomorrow">Level 1</div>
              <h3 className="academy-level font-bauhaus-medium">
                {t("knowledge.academy.basic.title")}
              </h3>
              <p className="academy-description font-tomorrow">
                {t("knowledge.academy.basic.description")}
              </p>
              <div className="academy-status font-tomorrow">{t("knowledge.academy.status")}</div>
            </div>

            <div className="academy-card">
              <div className="academy-badge font-tomorrow">Level 2</div>
              <h3 className="academy-level font-bauhaus-medium">
                {t("knowledge.academy.intermediate.title")}
              </h3>
              <p className="academy-description font-tomorrow">
                {t("knowledge.academy.intermediate.description")}
              </p>
              <div className="academy-status font-tomorrow">{t("knowledge.academy.status")}</div>
            </div>

            <div className="academy-card">
              <div className="academy-badge font-tomorrow">Level 3</div>
              <h3 className="academy-level font-bauhaus-medium">
                {t("knowledge.academy.advanced.title")}
              </h3>
              <p className="academy-description font-tomorrow">
                {t("knowledge.academy.advanced.description")}
              </p>
              <div className="academy-status font-tomorrow">{t("knowledge.academy.status")}</div>
            </div>
          </div>
        </div>
      </section>

      {/* User Guides Section */}
      <section className="knowledge-guides-section">
        <div className="knowledge-content-container">
          <div className="section-header">
            <div className="section-subtitle font-tomorrow">
              {t("knowledge.guides.sectionTitle")}
            </div>
            <h2 className="section-title font-bauhaus-medium">
              {t("knowledge.guides.title")}
            </h2>
          </div>

          <div className="guides-list">
            <div className="guide-item">
              <div className="guide-number">01</div>
              <div className="guide-content">
                <p className="font-tomorrow">{t("knowledge.guides.item1")}</p>
              </div>
              <div className="guide-arrow">→</div>
            </div>

            <div className="guide-item">
              <div className="guide-number">02</div>
              <div className="guide-content">
                <p className="font-tomorrow">{t("knowledge.guides.item2")}</p>
              </div>
              <div className="guide-arrow">→</div>
            </div>

            <div className="guide-item">
              <div className="guide-number">03</div>
              <div className="guide-content">
                <p className="font-tomorrow">{t("knowledge.guides.item3")}</p>
              </div>
              <div className="guide-arrow">→</div>
            </div>

            <div className="guide-item">
              <div className="guide-number">04</div>
              <div className="guide-content">
                <p className="font-tomorrow">{t("knowledge.guides.item4")}</p>
              </div>
              <div className="guide-arrow">→</div>
            </div>
          </div>
        </div>
      </section>

      {/* Investor Toolkit Section */}
      <section className="knowledge-toolkit-section">
        <div className="knowledge-content-container">
          <div className="section-header">
            <div className="section-subtitle font-tomorrow">
              {t("knowledge.toolkit.sectionTitle")}
            </div>
            <h2 className="section-title font-bauhaus-medium">
              {t("knowledge.toolkit.title")}
            </h2>
            <p className="section-description font-tomorrow">
              {t("knowledge.toolkit.description")}
            </p>
          </div>

          <div className="toolkit-grid">
            <div className="toolkit-card">
              <div className="toolkit-label font-tomorrow">Tool 01</div>
              <h3 className="toolkit-name font-bauhaus-medium">
                {t("knowledge.toolkit.item1.title")}
              </h3>
              <p className="toolkit-description font-tomorrow">
                {t("knowledge.toolkit.item1.description")}
              </p>
              <div className="toolkit-status font-tomorrow">{t("knowledge.toolkit.status")}</div>
            </div>

            <div className="toolkit-card">
              <div className="toolkit-label font-tomorrow">Tool 02</div>
              <h3 className="toolkit-name font-bauhaus-medium">
                {t("knowledge.toolkit.item2.title")}
              </h3>
              <p className="toolkit-description font-tomorrow">
                {t("knowledge.toolkit.item2.description")}
              </p>
              <div className="toolkit-status font-tomorrow">{t("knowledge.toolkit.status")}</div>
            </div>

            <div className="toolkit-card">
              <div className="toolkit-label font-tomorrow">Tool 03</div>
              <h3 className="toolkit-name font-bauhaus-medium">
                {t("knowledge.toolkit.item3.title")}
              </h3>
              <p className="toolkit-description font-tomorrow">
                {t("knowledge.toolkit.item3.description")}
              </p>
              <div className="toolkit-status font-tomorrow">{t("knowledge.toolkit.status")}</div>
            </div>

            <div className="toolkit-card">
              <div className="toolkit-label font-tomorrow">Tool 04</div>
              <h3 className="toolkit-name font-bauhaus-medium">
                {t("knowledge.toolkit.item4.title")}
              </h3>
              <p className="toolkit-description font-tomorrow">
                {t("knowledge.toolkit.item4.description")}
              </p>
              <div className="toolkit-status font-tomorrow">{t("knowledge.toolkit.status")}</div>
            </div>
          </div>
        </div>
      </section>

      {/* Expert Corner Section */}
      <section className="knowledge-expert-section">
        <div className="knowledge-content-container">
          <div className="section-header">
            <div className="section-subtitle font-tomorrow">
              {t("knowledge.expert.sectionTitle")}
            </div>
            <h2 className="section-title font-bauhaus-medium">
              {t("knowledge.expert.title")}
            </h2>
            <p className="section-description font-tomorrow">
              {t("knowledge.expert.description")}
            </p>
          </div>

          <div className="expert-content">
            <div className="expert-highlights">
              <div className="expert-card">
                <div className="expert-card-number font-bauhaus-medium">01</div>
                <h3 className="expert-card-title font-bauhaus-medium">{t("knowledge.expert.card1.title")}</h3>
                <p className="expert-card-text font-tomorrow">{t("knowledge.expert.item1")}</p>
                <div className="expert-card-status font-tomorrow">{t("knowledge.expert.status")}</div>
              </div>
              
              <div className="expert-card">
                <div className="expert-card-number font-bauhaus-medium">02</div>
                <h3 className="expert-card-title font-bauhaus-medium">{t("knowledge.expert.card2.title")}</h3>
                <p className="expert-card-text font-tomorrow">{t("knowledge.expert.item2")}</p>
                <div className="expert-card-status font-tomorrow">{t("knowledge.expert.status")}</div>
              </div>
              
              <div className="expert-card">
                <div className="expert-card-number font-bauhaus-medium">03</div>
                <h3 className="expert-card-title font-bauhaus-medium">{t("knowledge.expert.card3.title")}</h3>
                <p className="expert-card-text font-tomorrow">{t("knowledge.expert.item3")}</p>
                <div className="expert-card-status font-tomorrow">{t("knowledge.expert.status")}</div>
              </div>
            </div>
            
            <div className="expert-cta-box">
              <div className="expert-cta-content">
                <h3 className="expert-cta-title font-bauhaus-medium">{t("knowledge.expert.cta.title")}</h3>
                <p className="expert-cta-text font-tomorrow">
                  {t("knowledge.expert.cta.description")}
                </p>
              </div>
              <button className="btn-expert-notify font-tomorrow">{t("knowledge.expert.cta.button")}</button>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="knowledge-final-cta">
        <div className="final-cta-content">
          <h2 className="final-cta-title font-bauhaus-medium">
            {t("knowledge.finalCta.title")}
          </h2>
          <p className="final-cta-description font-tomorrow">
            {t("knowledge.finalCta.description")}
          </p>
          <div className="final-cta-buttons">
            <button className="btn-cta-primary">
              {t("knowledge.finalCta.button1")}
            </button>
            <button className="btn-cta-secondary">
              {t("knowledge.finalCta.button2")}
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Knowledge;
